import { defineAsyncComponent } from 'vue';

export const SEASONAL_ANIMATIONS = {
  snow: defineAsyncComponent(
    () => import('@/v2/components/animations/SnowCanvas.vue')
  )
};
